import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocaleFromPath } from '@/i18n/routes';

/** Syncs i18n language with URL on every navigation */
export const LocaleSync = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const locale = getLocaleFromPath(pathname);

  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
    document.documentElement.lang = locale;
  }, [locale, i18n]);

  return null;
};
